import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { ContactFormSchema } from './schema';

interface Props {
  form: UseFormReturn<ContactFormSchema>;
  activeCategory: string;
}

export const ContactFormReportReasonField: React.FC<Props> = ({ form, activeCategory }) => {
  if (activeCategory !== 'Report a Review') return null;
  return (
    <FormField
      control={form.control}
      name="report_reason"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Reason for reporting</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a reason" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="Offensive content">Offensive content</SelectItem>
              <SelectItem value="Spam">Spam</SelectItem>
              <SelectItem value="Misinformation">Misinformation</SelectItem>
              <SelectItem value="Inappropriate">Inappropriate</SelectItem>
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
